import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Optional } from "sprint-common-web";

import { ContentAssociationValidation } from "../../../../../../common/content/types/AssociateContentFormValidationRules";
import { ContentAssociationFormState } from "../../../../../../common/content/types/ContentAssociationFormState";
import { useCloudFileDashboard } from "../../../../common/context/useCloudFileDashboard";
import { useCloudFileDetails } from "../../../../common/useCloudFileDetails";
import { CloudFileAssociationFormState } from "../../context/CloudFileAssociationContext";
import { shouldDisableCloudFileEdit } from "../../utils/shouldDisableCloudFileEdit";

export const useCloudFileAssociateContentForm = () => {
    const { data: cloudFileDetails, isLoading: areCloudFileDetailsLoading } = useCloudFileDetails();

    const { lookupFileRecordId, setIsInactiveContentSelected } = useCloudFileDashboard();

    const [defaultContentState, setDefaultContentState] = useState<Optional<ContentAssociationFormState>>(undefined);

    const validation = getCloudFileContentAssociationValidation();

    const form = useFormContext<CloudFileAssociationFormState>();

    const onInactiveContentSelectionChange = (value: boolean) => {
        setIsInactiveContentSelected(value);
    };

    const isEditDisabled = !!cloudFileDetails && shouldDisableCloudFileEdit(cloudFileDetails);

    return {
        defaultContentState,
        setDefaultContentState,
        onInactiveContentSelectionChange,
        isDefaultContentLoading: areCloudFileDetailsLoading,
        validation,
        isEditDisabled,
        cloudFileDetails,
        lookupFileRecordId,
        form
    };
};

const getCloudFileContentAssociationValidation = (): ContentAssociationValidation => {
    return {
        rules: {
            isTitleRequired: false,
            areVersionsRequired: false,
            isAirlineRequired: true,
            isEpisodeRequired: false,
            isSeasonRequired: false
        }
    };
};
